<template>
  <component
    :is="tag"
    class="CrewListLabel"
  >
    <component
      v-for="crew in crews"
      :key="crew.id"
      :is="isClickable ? RouterLink : 'span'"
      class="CrewListLabel__link"
      :to="isClickable ? getRouteForCrew(crew.id) : undefined"
      @click="isClickable ? handleCrewClick($event, crew) : undefined"
    >
      {{ crew.name }}
    </component>
  </component>
</template>

<script lang="ts" setup>
import getRouteForCrew from "@/lib/utils/route/getRouteForCrew";
import useCrewStore from "@/stores/useCrewStore";
import { CrewSummary } from "@shared/lib/database/query.types";
import { RouterLink } from "vue-router";

const {
  crews,
  tag = "div",
  isClickable = false,
} = defineProps<{
  crews: Array<CrewSummary>,
  tag?: string,
  isClickable?: boolean,
}>();

const {
  viewCrew,
} = useCrewStore();

function handleCrewClick (e: MouseEvent, crew: CrewSummary) {
  e.preventDefault();
  viewCrew(crew);
}
</script>

<style lang="scss" scoped>
.CrewListLabel {
  overflow: hidden;

  font-size: 13px;
  font-weight: var(--fontWeightMedium);
  font-stretch: var(--fontWidthExtended);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.CrewListLabel__link {
  &:not(:last-child)::after {
    content: ", ";
  }
}
</style>
